<template>
  <NewAberrationContainer />
</template>

<script lang="ts">
import Vue from "vue";
import NewAberrationContainer from "@/components/aberration/new/aberration/NewAberrationContainer.vue";

export default Vue.extend({
  components: {
    NewAberrationContainer,
  },
});
</script>
